import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useClientGroupPageRedirect = () => {
  return usePagesRedirect('clientGroupPage');
};
